export interface PosthogPersonTraitInput {
	sqid: string;
	identityStatus: string;
	userType: string;
	platformStatus: string;
	customerStatus: string;
	advocacyStatus: string;
	currentLifecycleStage: string;
	furthestLifecycleStage: string;
	firstAttributedSource: string;
	lastAttributedSource: string;
	email?: string | null;
	name?: string | null;
	companyName?: string | null;
	companyRole?: string | null;
	emailVerified?: boolean;
}

export function buildPosthogPersonTraits(
	input: PosthogPersonTraitInput,
): Record<string, unknown> {
	const traits: Record<string, unknown> = {
		sqid: input.sqid,
		identity_status: input.identityStatus,
		user_type: input.userType,
		platform_status: input.platformStatus,
		customer_status: input.customerStatus,
		advocacy_status: input.advocacyStatus,
		current_lifecycle_stage: input.currentLifecycleStage,
		furthest_lifecycle_stage: input.furthestLifecycleStage,
		first_attributed_source: input.firstAttributedSource,
		last_attributed_source: input.lastAttributedSource,
	};
	if (input.email) {
		traits.email = input.email;
	}
	if (input.name) {
		traits.name = input.name;
	}
	if (input.companyName) {
		traits.company_name = input.companyName;
	}
	if (input.companyRole) {
		traits.company_role = input.companyRole;
	}
	if (input.emailVerified != null) {
		traits.email_verified = input.emailVerified;
	}
	return traits;
}
